import { Getters } from 'vuex-smart-module';
import AlfaApiLoanApplicationStatusesState from './state';

export default class AlfaApiLoanApplicationStatusesGetters extends Getters<AlfaApiLoanApplicationStatusesState> {}
